import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
} from "@material-ui/core";

import srms from '../images/sw-logo2.png'
import corona from '../images/corona-tracker.png'
import plate4u from '../images/plate4u.png'
import cdp from '../images/cdp.png'
import mobiletech from '../images/mobiletech.png'
import findTuition from '../images/find tuition.png'
import HealthCenter from '../images/Health cnter.png'
import Agri from '../images/Agri.png'
import PiggyBank from '../images/Piggy bank.png'
import sunTravels from '../images/sun travels.png'

const useStyles = makeStyles({
  '@global': {
    // You should target [class*="MuiButton-root"] instead if you nest themes.
    '.MuiCard-root': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    },
  },
  mainContainer: {
    background: "#233",
    height: "100%",
  },
  cardContainer: {
    maxWidth: 345,
    minHeight: 400,
    margin: "2rem auto",
    paddingBottom: '10px'
  },
  link: {
    display: 'flex',
    alignItems: 'flex-end',
  }
});

const Portfolio = () => {
  const classes = useStyles();

  function getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
  
    context.font = font || getComputedStyle(document.body).font;
  
    return context.measureText(text).width;
  }

  return (
    <Box component="div" className={classes.mainContainer}>
      <Grid container justify="center">
        {/* Project 1 */}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Student Request Management System"
                height="140"
                image={srms}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Student Request Management System
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A web application to be used by both students and academic administration 
                  to manage Faculty Academic Committee meeting, student requests and lecturer 
                  memos
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Project 2 */}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Career Developement Portal"
                height="140"
                image={cdp}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Career Developement Portal
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A career guidance portal to facilitate career guidance including 
                  the features such as: connect resource persons and needed students/ 
                  parents, connect job seekers and job providers, event management, 
                  Psychometric tests/ self-evaluation tests, post blogs/ videos, global 
                  search etc. 
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Project 3 */}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Find Tuition"
                height="140"
                image={findTuition}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Find Tuition
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A web application that enables a platform to be used by teachers, 
                  students and tuition institutes to meet and manage tuition related activities conveniently.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Project 4 */}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Corona Tracker"
                height="140"
                image={corona}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Corona Tracker
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A simple app using ReactJS to analyze statistical data about situations 
                  of covid-19 globally and locally
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <a href='https://covid19tracking.netlify.app/'>
                <Button size="small" color="primary">
                  Demo
                </Button>
              </a>
            </CardActions>
          </Card>
        </Grid>

        {/* Project 5 */}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="plate4u"
                height="140"
                image={plate4u}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  plate4u
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A web app using ReactJs, springboot and MSQL, that will suit for 
                  a restuarant. Through this app, you can order items, add to cart and book a table.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Project 6 */}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Mobile Tech"
                height="140"
                image={mobiletech}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Mobile Tech
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A simple web application to be used by a phone shop, integrated with 
                  CommerceJS
                </Typography>
              </CardContent>
            </CardActionArea>
            <CardActions>
              <a href='https://mobiletech.netlify.app/'>
                <Button size="small" color="primary">
                  Demo
                </Button>
              </a>
            </CardActions>
          </Card>
        </Grid>

        {/* Project 7*/}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Health Center"
                height="140"
                image={HealthCenter}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Health Center Management System
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A web application to manage all the activities inside a health center 
                  such as: managing patients details, prescriptions, medicines, and consultations.
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Project 8*/}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Agri"
                height="140"
                image={Agri}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Agri
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A web application to connect agricultural product farmers with customers
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Project 9*/}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Piggy Bank"
                height="140"
                image={PiggyBank}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Piggy Bank
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A web application which contains user authentication and managing expenses
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* Project 10*/}
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <Card className={classes.cardContainer}>
            <CardActionArea>
              <CardMedia
                component="img"
                alt="Piggy Bank"
                height="140"
                image={sunTravels}
              />
              <CardContent>
                <Typography gutterBottom variant="h5">
                  Hotel Reservation System
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  A web application which contains user authentication and managing expenses
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        
      </Grid>
    </Box>
  );
};

export default Portfolio;
